import { useNotificationStore } from '../notifications/notificationStore.js';
import { Icon } from './Icon.js';

/**
 * The header switch for system notifications.
 *
 * In the header rather than only in the account menu because a permission this
 * app never asks for on load has to be findable without being told where to
 * look - and because the icon doubles as the answer to "am I actually going to
 * be notified?", which is otherwise invisible state.
 *
 * Hidden entirely where the browser cannot do notifications at all: a control
 * that can never turn on is worse than no control. The account menu explains
 * why in words.
 */
export function NotificationBell() {
  const availability = useNotificationStore((state) => state.availability);
  const permission = useNotificationStore((state) => state.permission);
  const enabled = useNotificationStore((state) => state.enabled);
  const requesting = useNotificationStore((state) => state.requesting);
  const enable = useNotificationStore((state) => state.enable);
  const disable = useNotificationStore((state) => state.disable);

  if (availability !== 'available') {
    return null;
  }

  const blocked = permission === 'denied';
  const on = enabled && permission === 'granted';

  const label = blocked
    ? 'Notifications are blocked for this site. Allow them from the padlock menu in the address bar.'
    : on
      ? 'Message notifications are on. Click to turn them off.'
      : 'Turn on message notifications';

  return (
    <button
      type="button"
      className={on ? 'btn btn--icon bell bell--on' : 'btn btn--icon bell'}
      aria-label={label}
      title={label}
      aria-pressed={on}
      disabled={requesting || blocked}
      onClick={() => {
        if (on) {
          disable();
          return;
        }

        void enable();
      }}
    >
      <Icon name={on ? 'bell' : 'bellOff'} size={17} />
    </button>
  );
}
